module.exports = __webpack_public_path__ + "img/gold21.c64be5e8.svg";